// ============================================
// COMPONENT - Footer de paginación para tablas de Caja 360
// ============================================

interface PaginacionTablaProps {
  page: number;
  totalPages: number;
  totalElements: number;
  cantidadEnPagina: number;
  etiqueta?: string;
  onChange: (page: number) => void;
}

export const PaginacionTabla = ({
  page,
  totalPages,
  totalElements,
  cantidadEnPagina,
  etiqueta = 'registros',
  onChange,
}: PaginacionTablaProps) => {
  if (cantidadEnPagina === 0) return null;

  return (
    <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm text-gray-600">
          Mostrando {cantidadEnPagina} de {totalElements} {etiqueta}
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2">
          <button
            onClick={() => onChange(page - 1)}
            disabled={page === 0}
            className="px-3 py-1 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Anterior
          </button>

          <div className="flex flex-wrap items-center justify-center gap-1">
            {Array.from({ length: totalPages }, (_, i) => i).map((p) => {
              if (p === 0 || p === totalPages - 1 || (p >= page - 1 && p <= page + 1)) {
                return (
                  <button
                    key={p}
                    onClick={() => onChange(p)}
                    className={`px-3 py-1 rounded-lg text-sm transition-colors ${
                      p === page ? 'bg-[#43BFFF] text-white' : 'text-gray-700 hover:bg-gray-100'
                    }`}
                  >
                    {p + 1}
                  </button>
                );
              }
              if (p === page - 2 || p === page + 2) {
                return <span key={p} className="px-2 text-gray-400">...</span>;
              }
              return null;
            })}
          </div>

          <button
            onClick={() => onChange(page + 1)}
            disabled={page >= totalPages - 1}
            className="px-3 py-1 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
};
